module.exports = __webpack_public_path__ + "static/media/Logo_Black.0db6be37.png";